import { useAuth, useOrganization } from '@clerk/clerk-react'
import { useQuery } from '@tanstack/react-query'
import { QUERY_GC_TIME_MS, QUERY_STALE_TIME_MS } from '@/config/constants'
import { billingKeys } from '@/lib/queryKeys'
import { fetchDutyCallCosts } from '../api/api'
import type { DutyCallCostsResponse } from '../types'

/** Per-duty split of a period's call charges.
 *
 * Unlike month-end usage this reads per-call ledger rows, so it answers for
 * an open month as readily as a closed one and never needs a "period
 * closing" state. */
export function useDutyCallCostsQuery(period: string, enabled: boolean) {
  const { getToken } = useAuth()
  const { organization } = useOrganization()

  return useQuery<DutyCallCostsResponse>({
    queryKey: billingKeys.dutyCallCosts(organization?.id ?? '', period),
    queryFn: async ({ signal }) => {
      const token = await getToken()
      if (!token) throw new Error('No auth token available')
      return fetchDutyCallCosts(token, period, signal)
    },
    enabled: enabled && !!organization?.id,
    staleTime: QUERY_STALE_TIME_MS,
    gcTime: QUERY_GC_TIME_MS,
    refetchOnWindowFocus: false,
  })
}
